/**
 * File: footer.js
 *
 * Helpers for footer menus.
 */
class AccordionMenuWidget {
	constructor( menuWidget ) {
		this.menuWidget = menuWidget;
		this.button = this.menuWidget.querySelector( 'button.menu-toggle' );
		this.menuLinks = this.menuWidget.querySelectorAll( 'a' );
		this.expanded = false;
	}

	init() {
		this.button.addEventListener( 'click', ( event ) =>
			this.handleButtonClick( event )
		);

		this.menuLinks.forEach( ( menuLink ) => {
			menuLink.addEventListener( 'focus', ( event ) =>
				this.handleMenuLinkFocus( event )
			);
		} );
	}

	handleButtonClick() {
		this.expanded = ! this.expanded;

		this.button.setAttribute( 'aria-expanded', this.expanded.toString() );
	}

	handleMenuLinkFocus() {
		this.expanded = true;

		this.button.setAttribute( 'aria-expanded', this.expanded.toString() );
	}
}

( function () {
	const accordionMenuWidgets = document.querySelectorAll(
		'.site-footer .widget_nav_menu'
	);

	accordionMenuWidgets.forEach( ( accordionMenuWidget ) => {
		const menuWidget = new AccordionMenuWidget( accordionMenuWidget );
		menuWidget.init();
	} );

	const mediaQueryMobile = window.matchMedia( '(max-width: 600px)' );

	function handleScreenChange( e ) {
		if ( e.matches ) {
			accordionMenuWidgets.forEach( ( accordionMenuWidget ) => {
				accordionMenuWidget
					.querySelector( 'button.menu-toggle' )
					.setAttribute( 'aria-expanded', false );
			} );
		} else {
			accordionMenuWidgets.forEach( ( accordionMenuWidget ) => {
				accordionMenuWidget
					.querySelector( 'button.menu-toggle' )
					.setAttribute( 'aria-expanded', true );
			} );
		}
	}
	//add the event listener to the mediaQuery object
	mediaQueryMobile.addEventListener( 'change', handleScreenChange );

	handleScreenChange( mediaQueryMobile );
} )();
